var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJoomLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 85,
    r: 81,
    fill: "white",
    stroke: "#233C85",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.301 48.5572C134.301 41.3113 128.427 35.4375 121.181 35.4375C114.565 35.4375 109.096 40.3354 108.195 46.7026C108.111 46.658 108.062 46.6328 108.062 46.6328C97.3327 41.7935 88.2948 50.3647 88.2948 50.3647L64.3887 74.388L73.8346 83.4845L93.0764 64.5806C102.061 55.5951 106.954 61.6768 106.954 61.6768C113.718 67.3908 107.187 74.1549 107.187 74.1549L116.867 83.4845C124.771 74.9477 125.229 67.4971 122.826 61.5701C129.295 60.7602 134.301 55.2452 134.301 48.5572Z",
    fill: "#F9AE41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.948 108.892C122.992 108.809 123.018 108.76 123.018 108.76C127.857 98.0303 119.286 88.9929 119.286 88.9929L95.2621 65.0859L86.166 74.5323L105.07 93.774C114.055 102.76 107.974 107.652 107.974 107.652C102.26 114.416 95.4956 107.885 95.4956 107.885L86.166 117.564C94.7023 125.468 102.153 125.927 108.08 123.524C108.89 129.993 114.405 134.999 121.093 134.999C128.339 134.999 134.213 129.125 134.213 121.879C134.213 115.263 129.315 109.794 122.948 108.892Z",
    fill: "#EE4035"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4665 86.5156L76.2247 105.419C67.2392 114.405 62.3467 108.324 62.3467 108.324C55.5827 102.609 62.1136 95.8456 62.1136 95.8456L52.4346 86.516C44.5305 95.0523 44.072 102.503 46.4742 108.43C40.0054 109.24 35 114.755 35 121.443C35 128.689 40.8738 134.562 48.1197 134.562C54.7355 134.563 60.2048 129.665 61.1059 123.298C61.1901 123.342 61.2389 123.367 61.2389 123.367C71.9684 128.207 81.0059 119.635 81.0059 119.635L104.912 95.6117L95.4665 86.5156Z",
    fill: "#4F91CD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.231 76.2247C55.2455 67.2392 61.3264 62.3467 61.3264 62.3467C67.0412 55.5827 73.8049 62.1136 73.8049 62.1136L83.1345 52.435C74.5981 44.5309 67.1475 44.0724 61.2209 46.4746C60.4106 40.0054 54.896 35 48.2072 35C40.9617 35 35.0883 40.8738 35.0879 48.1197C35.0879 54.7359 39.9854 60.2052 46.3527 61.1063C46.308 61.1904 46.2832 61.2393 46.2832 61.2393C41.4427 71.9684 50.0147 81.0055 50.0147 81.0055L74.0388 104.912L83.1349 95.4665L64.231 76.2247Z",
    fill: "#7AC043"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoomLogo);
export default __webpack_public_path__ + "static/media/joomLogo.2e40b6a7cd7dc33144a45cad5459641b.svg";
export { ForwardRef as ReactComponent };